<template>
    <i
        class="iconfont"
        :class="
            fullscreen ? 'icon-exit-fullscreen' : icon || 'icon-full-screen'
        "
        :style="css"
        @click="click"
    ></i>
</template>
<script>
import util from '../../../common/util';
import Base from './base';
export default {
    mixins: [Base],
    props: ['icon'],
    data: function() {
        return {
            fullscreen: false
        };
    },
    mounted() {
        this.applyMap(([map, maps, siteMap]) => {
            map.addEventListener('mapviewchangeend', () => {
                this.fullscreen = util.isFullScreen();
            });
        });
    },
    methods: {
        handler([map, maps, siteMap]) {
            if (this.fullscreen) {
                exitFullscreen();
            } else {
                fullScreen(siteMap.$el);
            }
        }
    }
};

function fullScreen(element) {
    if (element.requestFullscreen) {
        element.requestFullscreen();
    } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    }
}

// Exit Full Screen
function exitFullscreen() {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
}
</script>
